const languageList = [
  { ar_AE: "阿拉伯联合酋长国" },
  { ar_BH: "巴林" },
  { ar_DZ: "阿尔及利亚" },
  { ar_EG: "埃及" },
  { ar_IQ: "伊拉克" },
  { ar_JO: "约旦" },
  { ar_KW: "科威特" },
  { ar_LB: "黎巴嫩" },
  { ar_LY: "利比亚" },
  { ar_MA: "摩洛哥" },
  { ar_OM: "阿曼" },
  { ar_QA: "卡塔尔" },
  { ar_SA: "沙特阿拉伯" },
  { ar_SD: "苏丹" },
  { ar_SY: "叙利亚" },
  { ar_TN: "突尼斯" },
  { ar_YE: "也门" },
  { be_BY: "白俄罗斯" },
  { bg_BG: "保加利亚" },
  { ca_ES: "西班牙" },
  { cs_CZ: "捷克共和国" },
  { da_DK: "丹麦" },
  { de_AT: "奥地利" },
  { de_CH: "瑞士" },
  { de_DE: "德国" },
  { de_LU: "卢森堡" },
  { el_GR: "希腊" },

  { en_GB: "英国" },
  { en_AU: "澳大利亚" },
  { en_CA: "加拿大" },
  { en_IE: "爱尔兰" },
  { en_NZ: "新西兰" },
  { en_US: "美国" },
  { en_ZA: "南非" },

  { es_BO: "玻利维亚" },
  { es_AR: "阿根廷" },
  { es_CL: "智利" },
  { es_CO: "哥伦比亚" },
  { es_CR: "哥斯达黎加" },
  { es_DO: "多米尼加共和国" },
  { es_EC: "厄瓜多尔" },
  { es_ES: "西班牙" },
  { es_GT: "危地马拉" },
  { es_HN: "洪都拉斯" },
  { es_MX: "墨西哥" },
  { es_NI: "尼加拉瓜" },

  { es_PA: "巴拿马" },
  { es_PE: "秘鲁" },
  { es_PR: "波多黎哥" },
  { es_PY: "巴拉圭" },
  { es_SV: "萨尔瓦多" },
  { es_UY: "乌拉圭" },
  { es_VE: "委内瑞拉" },
  { et_EE: "爱沙尼亚" },

  { fi_FI: "芬兰" },

  { fr_BE: "比利时" },
  { fr_CA: "加拿大" },
  { fr_CH: "瑞士" },
  { fr_FR: "法国" },
  { fr: "法国" },
  { fr_LU: "卢森堡" },

  { hr_HR: "克罗地亚" },

  { hu_HU: "匈牙利" },

  { is_IS: "冰岛" },

  { it_CH: "瑞士" },
  { it_IT: "意大利" },

  { iw_IL: "以色列" },
  { ja: "日本" },
  { ja_JP: "日本" },
  { ko: "韩国" },

  { ko_KR: "南朝鲜" },

  { lt_LT: "立陶宛" },

  { lv_LV: "拉脱维亚" },

  { mk_MK: "马其顿王国" },

  { nl_BE: "比利时" },
  { nl_NL: "荷兰" },

  { no_NO: "挪威" },

  { pl_PL: "波兰" },

  { pt_BR: "巴西" },
  { pt_PT: "葡萄牙" },

  { ro_RO: "罗马尼亚" },

  { ru_RU: "俄罗斯" },

  { sh_YU: "南斯拉夫" },

  { sk_SK: "斯洛伐克" },

  { sl_SI: "斯洛文尼亚" },

  { sq_AL: "阿尔巴尼亚" },

  { sv_SE: "瑞典" },
  { th_TH: "泰国" },
  { tr_TR: "土耳其" },
  { uk_UA: "乌克兰" },
  { zh_CN: "中国大陆" },
  { zh_HK: "中国香港" },
  { zh_TW: "中国台湾" }
];
export default languageList;
